// third-party
import { FormattedMessage } from 'react-intl';

// assets
import BarChartOutlined from '@ant-design/icons/BarChartOutlined';

// type
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

// icons
const icons = { BarChartOutlined };

// ==============================|| MENU ITEMS - DATA ANALYTICS ||============================== //

const dataAnalytics: NavItemType = {
  id: 'data-analytics',
  title: <FormattedMessage id="data-analytics" />,
  type: 'group',
  url: '/data-analytics',
  icon: icons.BarChartOutlined
};

export default dataAnalytics;
